<template>
  <div class="dashboard">
    <div class="widgets">
      <div class="widget hover" @click="view = 1" :class="{active: view === 1}">
        <div class="title">
          <span>Общее кол. продаж</span>
        </div>
        <div class="count">
          {{ Number(getAllSelling).toLocaleString() }}
        </div>
      </div>
      <div class="widget hover" @click="view = 2" :class="{active: view === 2}">
        <div class="title">
          <span>Общее кол. покупателей</span>
        </div>
        <div class="count">
          {{ orders ? Number(orders.totalCount).toLocaleString() : 0 }}
        </div>
      </div>
      <div class="widget">
        <div class="title">
          <span>Выручка</span>
          <div class="dates">
            <div class="dateFilter">
              <Datepicker :data="dataMoneyFrom" @set="valueMoneyFrom = $event" :value="valueMoneyFrom" label />
            </div>
            <div class="dateFilter">-</div>
            <div class="dateFilter">
              <Datepicker :data="dataMoneyTo" @set="valueMoneyTo = $event" :value="valueMoneyTo" label right />
            </div>
          </div>
        </div>
        <div class="count">
         {{ Number(money).toLocaleString() }} ₽
        </div>
      </div>
    </div>

    <div class="widgetsFull" v-if="view === 1">
      <div class="title">
        <span>Продажи</span>
      </div>
      <div class="widget">
        <div class="block">
          <myScroll>
            <div class="item" v-for="(item, i) in selling" :key="i">
              <div>
                {{ item.title }}
              </div>
              <div>
                {{ item.count }}
              </div>
            </div>
          </myScroll>
        </div>
      </div>
    </div>

    <div class="widgetsFull" v-if="view === 2">
      <div class="title">
        <span>Покупатели</span>
      </div>
      <div class="widget">
        <div class="block">
          <myScroll>
            <div class="item" v-for="(item, i) in orders.orders" :key="i">
              <div>
                {{ item.email }}
              </div>
              <div>
                <label v-for="(guide, i2) in item.guides" :key="i2" class="no-padding">
                  {{ guide.title }},
                </label>
              </div>
              <div>
                {{ getDate(item.date) }}
              </div>
            </div>
          </myScroll>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from '@/components/ui/Datepicker'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Datepicker
  },
  computed: {
    ...mapState('dashboard', [
      'selling',
      'orders',
      'money'
    ]),
    ...mapGetters('dashboard', [
      'getAllSelling'
    ]),
  },
  data () {
    return {
      view: 1,
      dataMoneyFrom: {label: 'Дата От', placeholder: 'Дата от', value: '', error: null, validate: false},
      dataMoneyTo: {label: 'Дата до', placeholder: 'Дата До', value: '', error: null, validate: false},
      valueMoneyFrom: null,
      valueMoneyTo: null
    }
  },
  watch: {
    valueMoneyFrom (val) {
      this.getFilter({from: val, to: this.valueMoneyTo})
    },
    valueMoneyTo (val) {
      this.getFilter({from: this.valueMoneyFrom, to: val})
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'getFilter'
    ]),
    getDate (date) {
      if (date) {
        const newDate = new Date(date)
        return `${newDate.getDate().toString().padStart(2, '0')}.${(newDate.getMonth() + 1).toString().padStart(2, '0')}.${newDate.getFullYear()} ${newDate.getHours().toString().padStart(2, '0')}:${newDate.getMinutes().toString().padStart(2, '0')}`
      }
      return null
    },
  },
  async mounted () {
    await this.getFilter()
  }
}
</script>

<style lang="scss" scoped>
.dashboard{
  @include box(100%, 100%, relative, null, null, null, null, null, null);
  @include flex(left, top, column);
  overflow: hidden;
  .widgets{
    @include box(100%, auto, relative, null, null, null, null, null, null);
    @include flex(left, top, row);
    .widget{
      @include box(25%, 100%, relative, null, null, null, null, null, #FFF);
      @include border(0.04vw, solid, $cardBorder, null, null, null, null);
      @include padding(2vw, 2vw, 2vw, 2vw);
      transition: 0.3s;
      .title{
        @include box(100%, 2.5vw, relative, null, null, null, null, null, null);
        @include flex(left, center, row);
        span{
          @include box(100%, null, relative, null, null, null, null, null, null);
          @include text(0.8vw, 400, 0.05vw, null, left, #999);
          text-transform: uppercase;
        }
        .dates{
          @include box(60%, null, relative, null, null, null, null, null, null);
          @include flex(left, center, row);
          flex-shrink: 0;
          .dateFilter{
            @include box(50%, null, relative, null, null, null, null, null, null);
            &:nth-child(2){
              @include box(15%, null, relative, null, null, null, null, null, null);
              @include flex(center, center, row);
            }
          }
        }
      }
      .count{
        @include box(100%, auto, relative, null, null, null, null, null, null);
        @include text(1.5vw, 400, 0.05vw, null, left, $modalText);
        @include padding(0, 0.5vw, 0, 0);
      }
      &.hover:hover{
        cursor: pointer;
        opacity: 0.5;
      }
      &.active{
        background-color: #F8F8F8;
        opacity: 1;
        cursor: default;
      }
      &:nth-child(3) {
        @include box(50%, auto, relative, null, null, null, null, null, #FFF);
      }
    }
  }
  .widgetsFull{
    @include box(100%, 100%, relative, null, null, null, null, null, null);
    @include flex(left, top, column);
    @include box(100%, 100%, relative, null, null, null, null, 0.2vw, #FFF);
    @include border(0.04vw, solid, $cardBorder, null, null, null, null);
    .title{
      @include box(100%, auto, relative, null, null, null, null, null, #F8F8F8);
      @include padding(2vw, 1vw, 2vw, 1vw);
      @include border(null, solid, $cardBorder, null, null, null, 0.04vw);
      @include flex(left, center, row);
      span{
        @include box(100%, null, relative, null, null, null, null, null, null);
        @include text(0.8vw, 400, 0.05vw, null, left, #999);
        text-transform: uppercase;
      }
      .dates{
        @include box(40%, null, relative, null, null, null, null, null, null);
        @include flex(left, center, row);
        .dateFilter{
          @include box(50%, null, relative, null, null, null, null, null, null);
          &:nth-child(2){
            @include box(15%, null, relative, null, null, null, null, null, null);
            @include flex(center, center, row);
          }
        }
      }
    }
    .widget{
      @include box(100%, 100%, relative, null, null, null, null, null, null);
      .block{
        @include box(100%, 100%, absolute, 0, 0, null, null, null, null);
        .item{
          @include box(100%, auto, relative, null, null, null, null, null, null);
          @include text(0.8vw, 400, 0.05vw, null, left, #444);
          @include border(null, solid, $cardBorder, null, null, null, 0.04vw);
          @include flex(left, center, row);
          align-items: stretch;
          div:nth-child(1){
            @include box(30%, null, relative, null, null, null, null, null, null);
            @include padding(2vw, 1vw, 2vw, 1vw);
          }
          div:nth-child(2){
            @include padding(2vw, 1vw, 2vw, 1vw);
            @include box(45%, null, relative, null, null, null, null, null, null);
            @include border(null, solid, $cardBorder, 0.04vw, null, null, null);
            @include text(0.9vw, 600, 0.05vw, null, left, #444);
            label{
              @include text(0.8vw, 400, 0.05vw, null, left, #444);
              &:nth-child(1) {
                @include padding(0, 0, 1vw, 0);
              }
              &:nth-child(2) {
                @include padding(1vw, 0, 0, 0);
              }
              &.no-padding{
                @include padding(0, 0, 0, 0);
              }
            }
          }
          div:nth-child(3){
            @include padding(2vw, 1vw, 2vw, 1vw);
            @include box(25%, null, relative, null, null, null, null, null, null);
            @include border(null, solid, $cardBorder, 0.04vw, null, null, null);
          }
        }
      }
    }
  }
}
</style>
